import { render, staticRenderFns } from "./inputChangeRegional.vue?vue&type=template&id=78a5f7d8&scoped=true&"
import script from "./inputChangeRegional.vue?vue&type=script&lang=js&"
export * from "./inputChangeRegional.vue?vue&type=script&lang=js&"
import style0 from "./inputChangeRegional.vue?vue&type=style&index=0&id=78a5f7d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a5f7d8",
  null
  
)

export default component.exports